import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/subtypes/[subtypeId]/todo_templates/Page";

export const PATH = (subtypeId: number): string =>
	`/settings/subtypes/${subtypeId}/todo_templates`;

const Home: NextPage = () => (
	<>
		<NskHead title="TODOテンプレート" />
		<Component />
	</>
);

export default Home;
